import { Component, Input } from '@angular/core';
import { EapStatus } from '@models/system-status';

@Component({
    selector: 'app-eap-status',
    templateUrl: './eap-status.component.html',
    styleUrls: ['./eap-status.component.scss'],
    standalone: false,
})
export class EapStatusComponent {
    @Input() eapArray: EapStatus[];
    @Input() isReceivingData: boolean;
}
